export default __webpack_public_path__ + "static/media/hero-art.5aa585d2.jpg";